// Compatibility import for existing API consumers; API and worker share one adapter.
export { createGitHubSkillSourceClient } from "@opengeni/core";
